import { useState, useEffect } from "react";
import { FrameState } from "@/types/types";

export const getInitialFirstWebProofState = (): FrameState => {
  const baseState: FrameState = {
    currentTutorialStep: 1,
    playwrightScript: "",
    proofOutput: "",
    frameIntegrations: [],
    selectedIntegration: undefined,
    loading: false,
    proofResultError: null,
  };

  return baseState;
};

export const useFirstWebProofState = () => {
  const [state, setState] = useState<FrameState>(
    getInitialFirstWebProofState()
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      // TODO: remove local storage for now
      // localStorage.setItem("pluto-quickstart-guide", JSON.stringify(state));
    }
  }, [state]);

  const updateState = (newState: Partial<FrameState>) => {
    setState((prevState) => {
      const updatedState = { ...prevState, ...newState };
      return updatedState;
    });
  };

  return { state, updateState };
};
